import { StreamActions } from '@hotwired/turbo'
import ClipboardJS from 'clipboard'

/**
 * Custom Turbo Stream action: share-success
 * Shows a SweetAlert success modal with the share link
 *
 * Usage in Twig:
 * <turbo-stream action="share-success" share-url="https://..."></turbo-stream>
 *
 * @param {Object} params
 * @param {App} app
 */
export default function init({ app }) {
    StreamActions['share-success'] = function () {
        const shareUrl = this.getAttribute('share-url')
        const message = this.getAttribute('message') || 'Your share link is available'

        // Show SweetAlert success modal with the share link
        /** @type {ModalManager} */
        const modalManager = app.get('modalManager')
        const tpl = `
            <input id="share-link-input" value="${shareUrl}" data-clipboard-text="${shareUrl}" type="text" class="form-control" readonly/>
            <div id="share-link-status" class="text-success mt-2 d-none">Copied to clipboard!</div>
        `

        modalManager.getSwal(tpl, message, {
            icon: 'success',
            didOpen: () => {
                const clipboard = new ClipboardJS('#share-link-input')
                clipboard.on('success', () => {
                    const status = document.getElementById('share-link-status')
                    if (status) {
                        status.classList.remove('d-none')
                    }
                })
            },
        })
    }
}
